import { all, takeEvery } from 'redux-saga/effects';

import { requestErrorWatch, FailureAction } from '~/store/general/requestErrorWatch';

import { authenticationSaga } from '~/store/user/sagas';
import { contractsSaga } from '~/store/contracts/sagas';
import { peopleSaga } from '~/store/people/sagas';
import { attendanceSaga } from '~/store/attendance/sagas';
import { agreementsSaga } from '~/store/agreements/sagas';
import { tagTypesSaga } from '~/store/tagTypes/sagas';
import { in100Saga } from '~/store/in100/sagas';
import { offersSaga } from '~/store/offers/sagas';
import { logsSaga } from '~/store/logs/sagas';
import { utilitiesSaga } from '~/store/utilities/sagas';
import { pendenciesSaga } from '~/store/pendencies/sagas';
import { clixSaga } from '~/store/clix/sagas';
import { tagsSaga } from '~/store/tags/sagas';
import { proposalsSaga } from '~/store/proposals/sagas';
import { accesByCustomerSaga } from '~/store/accessByCustomer/sagas';
import { ticketSaga } from '~/store/tickets/sagas';
import { permLevelsSaga } from '~/store/permLevels/sagas';
import { settingsSaga } from '~/store/settings/sagas';
import { notificationSaga } from '../sendPushNotification/sagas';
import { hisconSaga } from '../getHiscon/sagas';
import { hisconUpdateSaga } from '../requestHisconAutoUpdate/sagas';
import { getConcessionSaga } from '../getConcession/sagas';
import { getMedicalCertificateSaga } from '../getMedicalCertificate/sagas';
import { filesSaga } from '../files/sagas';
import { walletSaga } from '../wallet/sagas';
import { opportunitiesSaga } from '../opportunities/sagas';
import { enrollmentsSaga } from '../enrollments/sagas';
import { formalizationSaga } from '../formalization/sagas';
import { cardSaga } from '../cards/sagas';
import { consigneeSaga } from '../consignee/sagas';
import { courierSaga } from '../courier/sagas';
import { companySaga } from '../company/sagas';
import { cobrancaSaga } from '../cobranca/sagas';
import { insuranceSaga } from '../insurance/sagas';

function* requestWatch(): Generator {
  yield takeEvery((action: FailureAction) => action.type.endsWith('_FAILURE'), requestErrorWatch);
}

export default function* root(): Generator {
  yield all([
    authenticationSaga(),
    contractsSaga(),
    peopleSaga(),
    attendanceSaga(),
    agreementsSaga(),
    tagTypesSaga(),
    in100Saga(),
    offersSaga(),
    logsSaga(),
    utilitiesSaga(),
    pendenciesSaga(),
    clixSaga(),
    tagsSaga(),
    proposalsSaga(),
    accesByCustomerSaga(),
    notificationSaga(),
    hisconSaga(),
    hisconUpdateSaga(),
    getConcessionSaga(),
    getMedicalCertificateSaga(),
    filesSaga(),
    ticketSaga(),
    permLevelsSaga(),
    walletSaga(),
    opportunitiesSaga(),
    requestWatch(),
    enrollmentsSaga(),
    formalizationSaga(),
    cardSaga(),
    consigneeSaga(),
    courierSaga(),
    companySaga(),
    cobrancaSaga(),
    insuranceSaga(),
    settingsSaga(),
  ]);
}
